import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import * as theme from '../theme'
import { GridProvider, Grid, Row, Col } from 'zooper-grid'

class IndexPage extends React.Component {
  constructor(){
    super()
  }
  render(){
    const featuredImage = this.props.data.markdownRemark.frontmatter.featuredImage.childImageSharp.responsiveSizes
    return(
      <SiteWrapper>
        <Helmet>
          <title>Animator and Designer</title>
        </Helmet>
        {/* <Title>Animation & Design</Title> */}
        <VideoWrap>
          <VideoWrapInner>
            {/* <FeaturedImage
              src={featuredImage.src}
              srcSet={featuredImage.srcSet}
            /> */}
            <FullVideo autoPlay="autoplay" loop="true" muted="true" playsInline="true" width="1280" height="720">
              <source type="video/mp4" src="https://player.vimeo.com/external/125646400.hd.mp4?s=39beb785feceb7e668d30253e697589c466d6d76&profile_id=119"/>
            </FullVideo>
          </VideoWrapInner>
        </VideoWrap>
      </SiteWrapper>
    )
  }
}

const SiteWrapper = styled.div`
  width: 100%;
  min-height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Title = styled.h1`
  ${theme.title}
  color: white;
  margin: 0;
  font-size: 6vw;
  text-transform: uppercase;
  position: absolute;
  display: flex;
  z-index: 200;
  opacity: 0;
  ${'' /* opacity: 0;
  transform: translateY(6rem);
  animation: ${theme.fadeIn} 3000ms 300ms forwards ${theme.easing.OutQuint},
  ${theme.moveUp} 2000ms 350ms forwards ${theme.easing.OutQuint}; */}

`

const VideoWrap = styled.div`
  height: calc(100% - 10rem);
  width: calc(100% - 4rem);
  position: absolute;
  overflow: hidden;
  z-index: -100;
  border: 2px solid ${theme.primaryColour};

  opacity: 0;
  animation: ${theme.fadeIn} 1000ms forwards ${theme.easing.OutQuint};

  @media screen and (min-width: ${theme.mdMin}){
    height: calc(100% - 20rem);
    width: calc(100% - 8rem);
  }
`
const VideoWrapInner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`
const FullVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 300;
  opacity: 0;
  animation: ${theme.fadeIn} 1000ms 100ms forwards ${theme.easing.OutQuint};
`
const FeaturedImage = styled.img`
  min-height: 100%;
  min-width: 100%;
  height: auto;
  width: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 400;
  transform: translate(-50%,-50%);
  animation: ${theme.fadeIn} 1000ms 1000ms ease-in-out reverse forwards;
`

export const query = graphql`
  query HomeQuery {
    markdownRemark(fields: { slug: { regex: "/sticky-fingers-dreamland/"}}) {
      frontmatter {
        title
        featuredImage {
          childImageSharp {
            responsiveSizes {
              src
              srcSet
            }
          }
        }
      }
    },
    site {
      siteMetadata {
        title
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js